<template>
  <div class="card edit">
    <div class="card-body">
      <div class="d-flex align-items-center justify-content-between">
        <h5>Leerkrachten bewerken</h5>
        <div>
          <a class="btn btn-outline-primary btn-sm me-1" @click="newItem"
            >Nieuwe Leerkracht
            <font-awesome-icon icon="plus-circle" />
          </a>
          <a class="btn btn-outline-primary btn-sm" @click="$parent.detailEdit = ''"
            >Sluiten
            <font-awesome-icon icon="window-close" />
          </a>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <div v-if="mode !== ''" class="card mb-3">
            <div class="card-body row">
              <div class="col">
                <div class="form-floating mb-2">
                  <input type="text" class="form-control" :class="{ 'is-invalid': $v.teacher.achternaam.$error }" id="lastname" v-model="teacher.achternaam" />
                  <label for="lastname">Achternaam</label>
                </div>
                <div class="form-floating mb-2">
                  <input type="text" class="form-control" id="prefix" v-model="teacher.voorvoegsel" />
                  <label for="prefix">Voorvoegsel</label>
                </div>
                <div class="form-floating mb-2">
                  <input type="email" class="form-control" id="email" v-model="teacher.emailadres" />
                  <label for="email">Email</label>
                </div>

                <a class="btn btn-outline-primary btn-sm me-1" @click="cancelItem"
                  >Cancel
                  <font-awesome-icon icon="window-close" />
                </a>
                <a class="btn btn-secondary btn-sm" @click="saveItem"
                  >Leerkracht opslaan
                  <font-awesome-icon icon="save" />
                </a>
              </div>
              <div class="col">
                <div class="form-floating mb-2">
                  <input type="text" class="form-control" id="initials" v-model="teacher.voorletters" />
                  <label for="initials">Voorletters</label>
                </div>
                <div class="form-floating mb-2">
                  <input type="text" class="form-control" id="name" v-model="teacher.roepnaam" />
                  <label for="name">Roepnaam</label>
                </div>
                <div class="form-group mb-2">
                  <label>Groepen</label>
                  <multiselect v-model="teacher.groepen.groep" placeholder="Groepen" label="naam" track-by="naam" :hideSelected="true" :selectLabel="'Selecteren'" :deselectLabel="'Verwijderen'" :selectedLabel="'Geselecteerd'" :options="groupOptions" :multiple="true"></multiselect>
                </div>
                <div v-if="this.content.groepen.samengestelde_groep" class="form-group mb-2">
                  <label>Samengestelde groep</label>
                  <multiselect
                    v-model="teacher.groepen.samengestelde_groep"
                    placeholder="Kies een Samengestelde groep"
                    label="naam"
                    track-by="naam"
                    :hideSelected="true"
                    :selectLabel="'Selecteren'"
                    :deselectLabel="'Verwijderen'"
                    :selectedLabel="'Geselecteerd'"
                    :options="composedGroupOptions"
                    :multiple="true"
                  ></multiselect>
                </div>
              </div>
            </div>
          </div>
          <!-- OVERVIEW -->
          <div class="accordion" id="overview-accordion">
            <div class="accordion-item">
              <h2 class="accordion-header" id="overview">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#overview-list" aria-expanded="true" aria-controls="overview-list">Overzicht Leerkrachten</button>
              </h2>
              <div id="overview-list" class="accordion-collapse collapse show" aria-labelledby="overview" data-bs-parent="#overview">
                <div class="accordion-body">
                  <ul class="list-group">
                    <li v-for="(leerkracht, index) in content.leerkrachten.leerkracht" :key="leerkracht.key.key" class="list-group-item d-flex align-items-center justify-content-between">
                      {{ leerkracht.roepnaam }} {{ leerkracht.voorvoegsel }} {{ leerkracht.achternaam }}
                      <span>
                        <button :disabled="disableButtons" class="btn btn-outline-primary btn-sm me-2" @click="editItem(index)">
                          Bewerk
                          <font-awesome-icon icon="edit" />
                        </button>
                        <button :disabled="disableButtons" class="btn btn-outline-primary btn-sm" @click="deleteItem(index)">
                          Verwijder
                          <font-awesome-icon icon="trash-alt" />
                        </button>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import getUniqueKey from "@/helpers/getUniqueKey";

const getInitTeacher = () => {
  return {
    key: { key: "" },
    groepen: { groep: [] },
    samengestelde_groepen: { samengestelde_groep: null },
  };
};

export default {
  name: "teacherEdit",

  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      teacher: getInitTeacher(),
      mode: "",
      groupOptions: this.content.groepen.groep,
      composedGroupOptions: this.content.groepen.samengestelde_groep,
      disableButtons: false,
    };
  },
  validations: {
    teacher: {
      achternaam: {
        required,
      },
    },
  },
  methods: {
    saveItem() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      if (this.mode === "new") {
        this.teacher.key.key = getUniqueKey();
        this.content.leerkrachten.leerkracht.push(this.teacher);
        this.$toast.success("Leerkracht toegevoegd");
        this.mode = "";
        this.disableButtons = false;
      } else {
        let originalTeachers = [...this.content.leerkrachten.leerkracht];
        let getTeacherId = originalTeachers.findIndex((element) => element.key.key === this.teacher.key.key);
        originalTeachers[getTeacherId] = { ...originalTeachers[getTeacherId], ...this.teacher };
        this.content.leerkrachten.leerkracht = originalTeachers;

        this.$toast.success("Leerkracht gewijzigd");
        this.mode = "";
        this.$v.$reset();
        this.group = getInitTeacher();
        this.disableButtons = false;
      }
    },
    newItem() {
      this.disableButtons = true;
      this.mode = "new";
      this.$v.$reset();
      this.teacher = getInitTeacher();
    },
    editItem(i) {
      this.disableButtons = true;
      this.teacher = { ...this.content.leerkrachten.leerkracht[i] };
      if (!this.teacher.samengestelde_groepen) {
        this.teacher.samengestelde_groepen = { samengestelde_groep: null };
      }
      this.mode = "edit";
      window.scrollTo(0, 0);
    },
    deleteItem(i) {
      this.$delete(this.content.leerkrachten.leerkracht, i);
      this.$toast.success("Leerkracht verwijderd");
      window.scrollTo(0, 0);
    },
    cancelItem() {
      this.mode = "";
      this.$v.$reset();
      this.disableButtons = false;
      this.teacher = getInitTeacher();
    },
  },
};
</script>
